import { presentQueryValue } from '../../utils/confirmationAccess';
import {
  FLIGHT_FROM_QUERY_PARAM,
  FLIGHT_SEGMENT_COUNT_QUERY_PARAM,
  FLIGHT_SOURCE_CHATBOT,
  FLIGHT_SOURCE_QUERY_PARAM,
  FLIGHT_START_DATE_QUERY_PARAM,
  FLIGHT_TO_QUERY_PARAM,
  FLIGHT_TRIP_TYPE_MULTICITY,
  FLIGHT_TRIP_TYPE_QUERY_PARAM,
} from './flightSearchRoute.constants';

export function hasFlightSearchQuery(searchParams) {
  if (!searchParams || typeof searchParams.get !== 'function') return false;

  const source = presentQueryValue(searchParams.get(FLIGHT_SOURCE_QUERY_PARAM));
  if (source === FLIGHT_SOURCE_CHATBOT) return true;

  const tripType = presentQueryValue(searchParams.get(FLIGHT_TRIP_TYPE_QUERY_PARAM));
  const segmentCount = presentQueryValue(searchParams.get(FLIGHT_SEGMENT_COUNT_QUERY_PARAM));
  if (tripType === FLIGHT_TRIP_TYPE_MULTICITY && segmentCount) return true;

  const from = presentQueryValue(searchParams.get(FLIGHT_FROM_QUERY_PARAM));
  const to = presentQueryValue(searchParams.get(FLIGHT_TO_QUERY_PARAM));
  const startDate = presentQueryValue(searchParams.get(FLIGHT_START_DATE_QUERY_PARAM));
  return Boolean(from && to && startDate);
}
